import { useState, useEffect, useCallback } from "react";
import { getEventsForFavCompanies, getEvents } from "utils/api";
import moment from "moment";
import { getMinMaxCordinates } from "utils/helpers";

function descendingSortingDate(data = []) {
  const ascendingDate = [...data];
  return ascendingDate.sort(
    (a, b) =>
      new Date(b.date) - new Date(a.date) ||
      a.description.localeCompare(b.description, "de") ||
      a.name.localeCompare(b.name, "de")
  );
}

export default function useEventsToDisplay(dateRange, selectedChannels, bounds) {
  const [updateEvents, setUpdateEvents] = useState(0);
  const [checkedOnlyFavs, setCheckedOnlyFavs] = useState(false);
  const [isLoadingEvents, setIsLoadingEvents] = useState(false);
  const [filteredEvents, setFilteredEvents] = useState([]);

  const getEventsCall = useCallback(async () => {
    const params = checkedOnlyFavs
      ? {
          startDate: moment.unix(dateRange.startDate).format("YYYY-MM-D"),
          endDate: moment.unix(dateRange.endDate).format("YYYY-MM-D"),
        }
      : {
          channels: selectedChannels,
          coordinates: getMinMaxCordinates(bounds),
          dateRange: {
            startDate: moment.unix(dateRange.startDate).format("YYYY-MM-D"),
            endDate: moment.unix(dateRange.endDate).format("YYYY-MM-D"),
          },
        };
    const fn = checkedOnlyFavs ? getEventsForFavCompanies : getEvents;
    const data = await fn(params);
    return data;
  }, [bounds, checkedOnlyFavs, dateRange.endDate, dateRange.startDate, selectedChannels]);

  useEffect(() => {
    const exec = async () => {
      setIsLoadingEvents(true);
      try {
        const data = await getEventsCall();
        setFilteredEvents(descendingSortingDate(data));
        setIsLoadingEvents(false);
      } catch (e) {}
    };
    if (bounds) {
      exec();
    }
  }, [bounds, getEventsCall]);
  return [
    setUpdateEvents,
    updateEvents,
    setCheckedOnlyFavs,
    isLoadingEvents,
    filteredEvents,
    checkedOnlyFavs,
    setFilteredEvents,
  ];
}
